var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-card',{staticClass:"shadow-none mb-3",attrs:{"header-bg-variant":"transparent","bg-variant":"transparent","body-bg-variant":"white","body-class":"shadow-sm"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }